import AboutSubPage from "@/pages/about/components/AboutSubPage";

export default function ManagementFrPage() {
  return (
    <AboutSubPage
      heroImageSrc="https://net-basis.net/Bilder/christof-guenther-ict-management-dach.webp"
      texts={{
        title: "Direction",
        heroClaimLine1: "Propulsé par l'expertise !",
        heroClaimLine2: "",
        bottomClaim: "NetBasis International - drive to excellence with excellent drivers !",
      }}
      metaTitle="Direction – Christof Günther | NetBasis International"
      metaDescription="Christof Günther dirige le développement commercial B2B dans la région DACH en tant que propriétaire-exploitant avec plus de 30 ans d'expertise TIC."
      metaOgUrl="https://net-basis.net/fr/a-propos/direction"
    >
      <div className="flex flex-col md:flex-row md:items-start gap-8 md:gap-12">
        <div className="flex-shrink-0 flex justify-center md:justify-start">
          <div className="w-48 md:w-52 h-auto overflow-hidden rounded-lg border border-background-200">
            <img loading="lazy"
              src="https://net-basis.net/Bilder/CG-Foto.jpg"
              alt="Christof Günther"
              title="Christof Günther - NetBasis International"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="flex-1 space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
          <h1 className="text-sm md:text-base font-semibold text-foreground-950 font-sans">
            Christof Günther – Fondateur, propriétaire et votre esprit stratégique pour un développement commercial B2B réussi dans la région DACH.
          </h1>
          <p>
            <strong className="text-primary-600">NetBasis International</strong> a été fondée par lui à Düsseldorf au début de l'année 2008 et est gérée par son propriétaire depuis lors.
          </p>
          <p>Avec plus de 30 ans d'expérience internationale approfondie dans le secteur des TIC, il aide efficacement les fabricants étrangers à s'implanter avec succès sur de nouveaux marchés grâce à leurs produits et solutions technologiques. Son expertise professionnelle se concentre délibérément sur tous les domaines clés du développement commercial stratégique et opérationnel. En étroite collaboration, il élabore pour et avec ses partenaires commerciaux des concepts d'entrée sur le marché complets et d'avenir, et les soutient de manière fiable dans l'exécution pratique et la gestion ciblée de l'ensemble de leurs projets.</p>
          <p>En outre, il met son expertise approfondie du marché et sa connaissance pointue du secteur à la disposition des entreprises intéressées dans le cadre de mandats de conseil spécialisés, ainsi que par le biais de formations sur mesure et de coachings individuels.</p>
          <p>Avant de fonder <strong className="text-primary-600">NetBasis International</strong>, M. Günther a passé de nombreuses années à des postes de direction de haut niveau – notamment en tant que directeur de succursale, directeur des ventes et directeur des exportations – au sein d'entreprises de télécommunications et d'informatique de taille moyenne opérant à l'échelle européenne et mondiale. Cette longue expertise managériale constitue le fondement solide de la réussite durable de vos projets à l'étranger.</p>
        </div>
      </div>
    </AboutSubPage>
  );
}